module.exports = __webpack_public_path__ + "static/media/pravis_vertical.430831f6.png";